editConditionController.$inject = ['$scope', '$translate', '$mdDialog', 'elementData', 'elementView'];
export function editConditionController($scope, $translate, $mdDialog, elementData, elementView) {

  $scope.editCondition = editCondition;
  $scope.cancel = cancel;
  $scope.delete = deleteCondition;
  $scope.condition = elementData;
  $scope.hasKeywords = hasKeywords;

  init();

  function editCondition(condition) {
    elementData.title = condition.title;
    elementData.keywords = condition.keywords;
    $mdDialog.hide({type: 'ok', data: elementData});
  }

  function cancel() {
    $mdDialog.cancel();
  }

  function deleteCondition(condition) {
    $mdDialog.hide({type: 'delete',  data: condition});
  }

  function hasKeywords(condition) {
    return condition.keywords.length > 0;
  }

  function init() {
    if ($scope.condition.keywords === undefined) {
      $scope.condition.keywords = []
    };
    
  }

}
